module.exports = __webpack_public_path__ + "img/home.6663f75b.svg";